import { Helmet } from 'react-helmet';
import { useLocation, useNavigation } from 'react-router-dom';

const ClearHelmetSeoOnNavigation = () => {
  const location = useLocation();
  const navigation = useNavigation();

  const isTransitioning = navigation.state === 'loading';

  if (isTransitioning) {
    return (
      <Helmet key={`clearing-${location.key}`}>
        <title></title>
        <link rel="canonical" href="" />
        <meta name="title" content="" />
        <meta name="description" content="" />
        <meta name="keywords" content="" />
        <meta name="robots" content="" />
        <meta name="author" content="" />
        <meta name="content-type" content="" />
        <meta name="twitter:card" content="" />
        <meta name="twitter:title" content="" />
        <meta name="twitter:description" content="" />
        <meta name="twitter:image" content="" />
        <meta name="twitter:image:alt" content="" />
        <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:url" content="" />
        <meta property="og:image" content="" />
        <meta property="og:type" content="" />
        <meta property="og:site_name" content="" />
      </Helmet>
    );
  }

  return null;
};

export default ClearHelmetSeoOnNavigation;
